import { useState, useEffect } from 'react';

export const useCookie = (name, defaultValue = null) => {
    const [value, setValue] = useState(() => {
        if (typeof window === 'undefined') return defaultValue;

        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`));

        return cookie ? cookie.split('=')[1] : defaultValue;
    });

    const setCookie = (newValue, options = {}) => {
        const { expires = 30, path = '/' } = options;
        const expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + (expires * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${newValue};expires=${expiresDate.toUTCString()};path=${path}`;
        setValue(newValue);
    };

    const removeCookie = () => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        setValue(null);
    };

    return [value, setCookie, removeCookie];
};
